import './Base.scss';
import './Modules/Modules.routes';
import {LoadModules} from "./Modules";
import {CustomThemeLoad} from "./Common/Context/ThemeContext";
import {UserLoad} from "./Common/Context/UserContext";
import {ThemeProvider} from "react-bootstrap";
import {ToastContainer} from "react-toastify";
import {MyRoutes} from "./Common/Component/Routes/Routes";
import {MenuLoad} from "./Common/Context/MenuContext";

LoadModules();

function App() {

    console.log('Renderizando app')

    return (
        <CustomThemeLoad>
            <UserLoad>
                <ThemeProvider breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']} minBreakpoint="xxs">
                    <MenuLoad>
                        <MyRoutes/>
                    </MenuLoad>
                    <ToastContainer/>
                </ThemeProvider>
            </UserLoad>
        </CustomThemeLoad>

    );
}

/*

 <!-- <UserLoad>
       <ThemeProvider
           breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
           minBreakpoint="xxs"
       >
           <MyRoutes/>
           <ToastContainer/>
       </ThemeProvider>
   </UserLoad>-->

 */

export default App;
